"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBusinessesOwnResponseAllOfToJSON = exports.GetBusinessesOwnResponseAllOfFromJSONTyped = exports.GetBusinessesOwnResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetBusinessesOwnResponseAllOfFromJSON(json) {
    return GetBusinessesOwnResponseAllOfFromJSONTyped(json, false);
}
exports.GetBusinessesOwnResponseAllOfFromJSON = GetBusinessesOwnResponseAllOfFromJSON;
function GetBusinessesOwnResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'businesses': (json['businesses'].map(_1.BusinessFromJSON)),
    };
}
exports.GetBusinessesOwnResponseAllOfFromJSONTyped = GetBusinessesOwnResponseAllOfFromJSONTyped;
function GetBusinessesOwnResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'businesses': (value.businesses.map(_1.BusinessToJSON)),
    };
}
exports.GetBusinessesOwnResponseAllOfToJSON = GetBusinessesOwnResponseAllOfToJSON;
